import Container from '../Container';
import BlogSearch from './BlogSearch';
import { BlogEnum } from '@/types/translations/BlogEnum';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import Link from 'next/link';
import React from 'react';

export default function BlogHeader() {
  const { translate } = useTypedTranslation<BlogEnum>('blog');

  return (
    <div className="tw-border tw-border-solid tw-border-r-0 tw-border-l-0 tw-border-[#EAEBF0]">
      <Container>
        <div className="max-nine:tw-gap-4 max-nine:tw-flex-col tw-flex nine:tw-items-center tw-justify-between tw-py-5 max-nine:tw-py-6">
          <div className="tw-flex tw-items-center tw-justify-start tw-gap-4 max-nine:tw-mx-auto">
            <div>
              <Link href="/blog" className={'tw-text-darkblue'}>
                {translate(BlogEnum.spiritory_news)}
              </Link>
            </div>
            <div>
              <Link href={'/blog/authors'} className={'tw-text-darkblue'}>
                {translate(BlogEnum.authors)}
              </Link>
            </div>
            <div></div>
          </div>
          <BlogSearch />
        </div>
      </Container>
    </div>
  );
}
